export const themeSlice = (set) => ({
    theme: {
        color: 'emerald',
        mode: 'light'
    },

    setThemeColor: (color) => set((state) => ({ theme: { ...state.theme, color } })),
    toggleThemeMode: () => set((state) => ({ theme: { ...state.theme, mode: state.theme.mode === 'light' ? 'dark' : 'light' } }))
})